import React, { useEffect, useState } from "react";
import '../../../../assets/css/valuelist.css';
import MainWrapper from "../../../MainWrapper";
import { Link, Navigate } from "react-router-dom";
import Icon from "react-icons-kit";
import { ic_arrow_back, ic_mode_edit, ic_save } from 'react-icons-kit/md';
import { Table, Form, Button, InputGroup } from 'react-bootstrap';
// import { encrypted } from '../../../../_utils/helpers';
import { connect } from 'react-redux';
import Create from "./models/Create";
import ConfirmDelete from "./models/ConfirmDelete";
import {
  SHIP_REQUEST,
  SHIP_CREATE,
  SHIP_DELETE,
  SHIP_EDIT,
  SHIP_STATE_CHANGE
} from "../../../../_utils/constants/ProductCatalog";
import Loader from "../../../layouts/Loader";
import { toast } from 'react-toastify';

const Ship = ({
  auth: { auth, isAuthenticated },
  Ship: { valueList, isCreated, isDeleted, isEdited, isLoading },
  fetchShip,
  submitShipCreate,
  submitShipDelete,
  submitShipEdit,
  changeReducerState
}) => {

  // states declarations
  const [createModalOpen, setCreateModalOpen] = useState(false);
  const [confirmDeleteModal, setConfirmDeleteModal] = useState(false);
  const [inputVal, setInputVal] = useState('');
  const [deleteShipId, setDeleteShipId] = useState('');
  const [editShipId, setEditShipId] = useState('');
  const [editShip, setEditShip] = useState('');

  // use effect function called for authentication
  useEffect(() => {
    if (isAuthenticated) {
      fetchShip(auth[0].token);
    }
  }, [auth, isAuthenticated]);

  // use effect function called after api success
  useEffect(() => {
    if (isCreated === true) {
      toast.success("Ship Created Successfully.");
      fetchShip(auth[0].token);
      changeReducerState();
    }
    if (isDeleted === true) {
      toast.success("Ship Deleted Successfully.");
      fetchShip(auth[0].token);
      changeReducerState();
    }
    if (isEdited === true) {
      toast.success("Ship Data Updated Successfully.");
      fetchShip(auth[0].token);
      changeReducerState();
    }
  }, [isCreated, isDeleted, isEdited]);

  // function to open create modal
  const showCreateModal = () => {
    setCreateModalOpen(true);
  };

  // function to close create modal
  const hideCreateModal = () => {
    setCreateModalOpen(false);
  };

  // function called for input value change of create modal
  const handleCreateModalChange = (e) => {
    setInputVal(e.target.value);
  }

  // function called for create age demographic create api
  const handleCreateModalSubmit = (e) => {
    e.preventDefault();
    if (inputVal === '') {
      toast.error("Ship name cannot be empty.");
    } else {
      submitShipCreate({
        "data": {
          "ShipVia": inputVal,
          "CreatedBy": auth[0].userId
        },
        "token": auth[0].token
      });
      hideCreateModal();
    }
  }

  // function to open confirm delete modal
  const showConfirmDeleteModal = (id) => {
    setDeleteShipId(id);
    setConfirmDeleteModal(true);
  };

  // function to close confirm delete modal
  const hideConfirmDeleteModal = () => {
    setDeleteShipId('');
    setConfirmDeleteModal(false);
  };

  // function called for delete age demographic delete api
  const handleConfirmDeleteSubmit = () => {
    submitShipDelete({
      "ShipId": deleteShipId,
      "token": auth[0].token
    });
    hideConfirmDeleteModal();
  }

  // function called on edit icon click
  const handleEditClick = (data) => {
    setEditShipId(data.shipId);
    setEditShip(data.shipVia);
  }

  // function called to save edited data
  const handleEditSaveClick = (data) => {
    if (editShip === '') {
      toast.error("Ship name cannot be empty.");
    } else {
      submitShipEdit({
        "data": {
          "ShipId": data.shipId,
          "ShipVia": editShip,
        },
        "token": auth[0].token
      });
      setEditShipId('');
      setEditShip('');
    }
  }

  if (!isAuthenticated) return <Navigate to="/login" />;

  return (
    <MainWrapper>
      <Loader loading={isLoading}>
        <div className="container">

          <div className="sub-header mt-5 mb-3">
            <h2>Ship</h2>
            <Link className="btn btn-primary me-1" to="/admin"><Icon icon={ic_arrow_back} />Back to Value List</Link>
            <Create
              variant="primary"
              title={`Ship`}
              createModalOpen={createModalOpen}
              showCreateModal={showCreateModal}
              hideCreateModal={hideCreateModal}
              inputVal={inputVal}
              handleCreateModalChange={handleCreateModalChange}
              handleCreateModalSubmit={handleCreateModalSubmit}
            />
          </div>
          <Table responsive bordered>
            <thead>
              <tr>
                <th>Ship</th>
                <th width="50">Delete</th>
              </tr>
            </thead>
            <tbody>
              {valueList && valueList.length > 0 ? (
                valueList.map((item, index) => (
                  <tr key={index}>
                    {editShipId === item.shipId ? (
                      <td>
                        <Form.Group>
                          <InputGroup>
                            <Form.Control type="text" value={editShip} onChange={(evt) => setEditShip(evt.target.value)} />
                            <Button variant="outline-secondary">
                              <Icon size={24} icon={ic_save} onClick={() => handleEditSaveClick(item)} />
                            </Button>
                          </InputGroup>
                        </Form.Group>
                      </td>
                    ) : (
                      <td>
                        {item.shipVia}
                        <Icon role="button" className="float-end" size={24} icon={ic_mode_edit} onClick={() => handleEditClick(item)} />
                      </td>
                    )}
                    <td>
                      <ConfirmDelete variant="primary" title={`Ship`} showConfirmDeleteModal={() => showConfirmDeleteModal(item.shipId)} hideConfirmDeleteModal={hideConfirmDeleteModal} handleConfirmDeleteSubmit={handleConfirmDeleteSubmit} confirmDeleteModal={confirmDeleteModal} />
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan={2}>
                    No Data Found.
                  </td>
                </tr>
              )}
            </tbody>
          </Table>
        </div>
      </Loader>
    </MainWrapper>
  );
}

const mapStateToProps = ({ auth, Ship }) => {
  return {
    auth,
    Ship
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    fetchShip: (token) => dispatch({ type: SHIP_REQUEST, token }),
    submitShipCreate: (data) => dispatch({ type: SHIP_CREATE, payload: data }),
    submitShipDelete: (data) => dispatch({ type: SHIP_DELETE, payload: data }),
    submitShipEdit: (data) => dispatch({ type: SHIP_EDIT, payload: data }),
    changeReducerState: () => dispatch({ type: SHIP_STATE_CHANGE })
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(Ship);